/* Copyright (c) 2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Text, theme, FlexContainer } from "@nordcloud/gnui";
import { SidebarItemWrapper } from "./styles";
import { Item } from "./types";

export type Props = {
  key: string;
  item: Item;
  onSubmit: (i: string) => void;
};

export function SidebarItem({ item, onSubmit }: Props) {
  return (
    <SidebarItemWrapper
      title={item?.value}
      onClick={() => onSubmit(item.value)}
    >
      <FlexContainer alignItems="start" direction="column">
        <Text
          size="md"
          tag="div"
          color={theme.color.text.text02}
        >{`${item?.label}`}</Text>
        <Text size="sm" tag="div" color={theme.color.text.text02}>
          {item?.value}
        </Text>
      </FlexContainer>
    </SidebarItemWrapper>
  );
}
